module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon0.2117645.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon0.png
// module id = Whtl
// module chunks = 1